import React from "react";

const Weed = ({ duration, delay, bottom, size }) => (
  <svg
    className="tumbleweed"
    viewBox="0 0 60 60"
    style={{
      animationDuration: `${duration}s`,
      animationDelay: `${delay}s`,
      bottom: `${bottom}%`,
      width: size,
      height: size,
    }}
    aria-hidden
  >
    <g fill="none" stroke="#5d3b00" strokeWidth="1.5" opacity="0.85">
      <circle cx="30" cy="30" r="22" />
      <path d="M8,30 Q30,8 52,30 Q30,52 8,30" />
      <path d="M14,18 L46,42 M46,18 L14,42 M30,8 L30,52 M8,30 L52,30" />
      <circle cx="30" cy="30" r="14" />
    </g>
  </svg>
);

const Tumbleweeds = () => (
  <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden>
    <Weed duration={11} delay={0} bottom={6} size={48} />
    <Weed duration={17} delay={5} bottom={11} size={64} />
    <Weed duration={9} delay={12} bottom={3} size={36} />
    <Weed duration={20} delay={18} bottom={14} size={56} />
  </div>
);

export default Tumbleweeds;
